module.exports = __webpack_public_path__ + "static/media/avatar-testimony-1.b751bbf3.png";